<mat-form-field appearance="outline" style="width: 100%;">
    <mat-label>{{'importer.line' | translate | capitalizeFirst}}</mat-label>
    <button mat-icon-button matSuffix type="button" aria-label="Clear selection" [disabled]="disabled"
        (click)="onSelectChange(null); $event.stopPropagation()">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
    <mat-select [(ngModel)]="value" (ngModelChange)="onSelectChange($event)" [disabled]="disabled" [multiple]="multiple">
        <mat-option *ngFor="let line of availableLines" [value]="line.value">
            {{ line.displayValue }}
        </mat-option>
    </mat-select>
</mat-form-field>